import { useDialog } from "lib/@hooks/useDialog"
import { parentSome } from "library/tree/index.mjs"
import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { createSubFolder } from "routes/schedule/folder-manager/controller/create-sub-folder"
import { ChooseFacilityOrSpace } from "routes/schedule/my-schedules/my-group-types/facility/chooseFacilityOrSpace"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useTreeItemIndex } from "routes/schedule/lib/useTreeItemIndex"

export function AddFacility() {
    const { parentItem, isRegimeSyncedToRegister, isUnlocked } = useBoundContext()
    const facility = useDialog(<ChooseFacilityOrSpace />, {
        maxWidth: "md",
    })
    useTreeItemIndex()

    if (parentSome(parentItem, (c) => c.data?.type === "facility")) {
        return null
    }

    return (
        (!isRegimeSyncedToRegister || isUnlocked) && (
            <Button
                data-cy="add-facility-btn"
                onClick={add}
                variant="outlined"
                color="primary"
                startIcon={<Iconify icon="bxs:building" />}
            >
                Add Facility
            </Button>
        )
    )

    async function add() {
        const result = await facility()
        if (result) {
            await createSubFolder(parentItem, result.name, result)
        }
    }
}
